import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "../lib/data";

export const FloatingButtons = () => (
  <div data-testid="floating-action-group" className="fixed bottom-5 right-5 z-50 flex flex-col gap-3">
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Discuter sur WhatsApp"
      className="relative w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white flex items-center justify-center shadow-xl shadow-emerald-600/30 transition-all hover:scale-105"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500 animate-pulse-ring" />
      <MessageCircle size={24} className="relative" />
    </a>
    <a
      href={PHONE_TEL}
      data-testid="floating-call-button"
      aria-label="Appeler WM Clean"
      className="w-14 h-14 rounded-full bg-sky-600 hover:bg-sky-700 text-white flex items-center justify-center shadow-xl shadow-sky-600/30 transition-all hover:scale-105"
    >
      <Phone size={22} />
    </a>
  </div>
);
